// extracted by mini-css-extract-plugin
module.exports = {"text":"style__text___1nttx","container-large":"style__container-large___3XKWL"};